// AWS S3 限制配置
const AWS_LIMITS = {
    MAX_PARTS: 10000,
    MIN_CHUNK_SIZE: 5 * 1024 * 1024, // 5MB
    MAX_OBJECT_SIZE: 5 * 1024 * 1024 * 1024 * 1024, // 5TB
};

// 默认配置
const DEFAULT_CONFIG = {
    concurrency: 10, // 并发上传数量
    retries: 10, // 重试次数
    retryDelay: 1000, // 重试延迟(ms)
};

// 验证结果枚举
const VALIDATION_RESULT = {
    VALID: 'valid',           // uploadId 有效
    INVALID: 'invalid',       // uploadId 确实无效，应该清除缓存
    UNKNOWN: 'unknown'        // 无法确定（网络问题等），不应清除缓存
};

// 错误类型枚举
const ERROR_TYPES = {
    NETWORK: 'network',
    BUSINESS: 'business',
    SYSTEM: 'system',
    AWS: 'aws',
    STORAGE: 'storage',
};

module.exports = {
    AWS_LIMITS,
    DEFAULT_CONFIG,
    VALIDATION_RESULT,
    ERROR_TYPES,
};
